import * as React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"

import "./spa.scss"


import SpaHero from "./components/SpaHero"
import OptionsGallery from "./components/OptionsGallery"
import Appointments from "./components/Appointments"


const spa = () => (
  <Layout>
    <Seo title="Spa | Ambergris Caye Hotels" />
    <SpaHero />
    <OptionsGallery />
    <Appointments />
    
  </Layout>
)

export default spa;
